import { createElement } from 'react';
import { Component } from 'react';
import { observer } from 'mobx-react';
import withStyles, { WithStyles } from 'react-jss';
import { ComponentDesc } from '../../store';
import { settingsPanelStyles as styles } from './styles';
import { ChromePicker } from 'react-color';
import reactCSS from 'reactcss';

interface IProps extends WithStyles<typeof styles> {
    descriptor: ComponentDesc<any>;
}

const color_picker = require('../icons/color_picker.svg');

class BoxShadow extends Component<IProps, any> {
    constructor(a, b) {
        super(a, b);
        this.props.descriptor.style.boxShadow = '0px 0px 0px 0px #fff';
    }

    state = {
        displayColorPicker: false,
    };

    updateBoxShadow(position, value) {
        let items = this.props.descriptor.style.boxShadow.split(' ');
        items.splice(position, 1, value);
        this.props.descriptor.style.boxShadow = items.join(' ');
    }

    handleClickColor = () => {
        this.setState({ displayColorPicker: !this.state.displayColorPicker });
    };
    handleChangeColor = (color) => {
        let changed_color = this.props.descriptor.style.boxShadow.split(' ');
        changed_color.splice(4, 1, color.hex);
        this.props.descriptor.style.boxShadow = changed_color.join(' ');
    };

    render() {
        let { descriptor } = this.props;
        const { classes } = this.props;
        return (
            <div className={classes.root}>
                <div className={classes.panel}>
                    <span className={classes.header} style={{ width: '85px' }}>
                        Box Shadow
                    </span>
                </div>

                <div
                    style={{
                        display: 'flex',
                        flexWrap: 'no-wrap',
                        alignItems: 'left',
                        justifyContent: 'center',
                        padding: '4px 0 5px',
                    }}>
                    <div className={classes.flex}>
                        <input className={classes.input} value={descriptor.style.boxShadow.split(' ').splice(0, 1)[0]} onChange={(e) => this.updateBoxShadow(0, e.target.value)} style={{ marginBottom: '5px' }} />
                        <span className={classes.sub_header}>X</span>
                    </div>

                    <div className={classes.flex}>
                        <input className={classes.input} value={descriptor.style.boxShadow.split(' ').splice(1, 1)[0]} onChange={(e) => this.updateBoxShadow(1, e.target.value)} style={{ marginBottom: '5px' }} />
                        <span className={classes.sub_header}>Y</span>
                    </div>

                    <div className={classes.flex} style={{ marginBottom: '5px' }}>
                        <input className={classes.input} value={descriptor.style.boxShadow.split(' ').splice(2, 1)[0]} onChange={(e) => this.updateBoxShadow(2, e.target.value)} style={{ marginBottom: '5px' }} />
                        <span className={classes.sub_header}>Blur</span>
                    </div>

                    <div className={classes.flex} style={{ marginBottom: '5px' }}>
                        <input className={classes.input} value={descriptor.style.boxShadow.split(' ').splice(3, 1)[0]} onChange={(e) => this.updateBoxShadow(3, e.target.value)} style={{ marginBottom: '5px' }} />
                        <span className={classes.sub_header}>Spread</span>
                    </div>

                    <div className={classes.flex} style={{ position: 'relative' }}>
                        <button
                            title="Pick Color"
                            style={{
                                backgroundColor: this.props.descriptor.style.boxShadow as string,
                                border: '2px solid transparent',
                                width: '40px',
                                height: '30px',
                                marginBottom: '5px',
                                borderRadius: '4px',
                            }}>
                            <img src={color_picker} onClick={this.handleClickColor} />
                        </button>
                        <span className={classes.sub_header}>Color</span>
                        {this.state.displayColorPicker ? (
                            <div
                                style={{
                                    position: 'absolute',
                                    right: '0',
                                    bottom: '50px',
                                    zIndex: 2,
                                }}>
                                <div
                                    style={{ position: 'fixed', top: '0px', left: '0px', right: '0px', bottom: '0px' }}
                                    onClick={(e) => {
                                        this.setState({
                                            displayColorPicker: !this.state.displayColorPicker,
                                        });
                                    }}
                                />
                                <ChromePicker color={this.props.descriptor.style.boxShadow} onChange={this.handleChangeColor} />
                            </div>
                        ) : null}
                    </div>
                </div>
            </div>
        );
    }
}

export default withStyles(styles)(observer(BoxShadow));
